import React from 'react'

import { Container } from '@ui/blocks/Container'
import { H1 } from '@ui/blocks/Heading'
import { Link } from '@ui/blocks/Link'
import { Text } from '@ui/blocks/Text'
import { WrappedContainer } from '@ui/blocks/WrappedContainer'
import { Asset } from '@app/graphql/cms/schema'

import {
  ArticleBody,
  ArticleHeading,
  ArticleImg,
  ArticleMeta,
  ArticleText,
  DesktopSocial,
  MobileSocial,
  Separator
} from './styles'
import SocialIcons from './SocialIcons'

interface ArticleData {
  coverImage?: Partial<Asset> | null
  content?: {
    html: string
  }
  title?: string
  publishedAt?: string
  blogparent?: {
    parentname: string
    parentslug: string
  } | null
}

interface ArticleProps {
  data?: ArticleData | null
  articleSlug: string
}

const SingleArticle = ({ data, articleSlug }: ArticleProps) => {
  const { content, coverImage, title, blogparent, publishedAt } = data || {}

  const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  const articleDate = new Date(publishedAt || '')
  const formattedDate = publishedAt && articleDate.toLocaleDateString('en-US', dateOptions)

  return (
    <WrappedContainer background="floralWhite">
      <div id="progress-bar-boundary">
        <Container>
          <ArticleHeading>
            <H1>{title}</H1>
            {blogparent && (
              <ArticleMeta>
                <ul>
                  <li>
                    <Text fontSize="1.2rem" color="elemyGreen" weight={700}>
                      {formattedDate}
                    </Text>
                  </li>
                  <li>
                    <Separator />
                  </li>
                  <li>
                    <Link to={`/studio/${blogparent?.parentslug}`}>
                      <Text fontSize="1.2rem" color="elemyGreen" weight={700}>
                        {blogparent?.parentname}
                      </Text>
                    </Link>
                  </li>
                </ul>
              </ArticleMeta>
            )}
          </ArticleHeading>
          <ArticleBody>
            <DesktopSocial>
              <SocialIcons articleSlug={articleSlug} />
            </DesktopSocial>
            {coverImage?.url && <ArticleImg src={coverImage?.url} alt="Article cover" />}
            <ArticleText dangerouslySetInnerHTML={{ __html: content?.html || '' }} />
            <MobileSocial>
              <SocialIcons articleSlug={articleSlug} />
            </MobileSocial>
          </ArticleBody>
        </Container>
      </div>
    </WrappedContainer>
  )
}

export default SingleArticle
